
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15px","height":"8px","viewBox":"0 0 15 8","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('Shape')]),_c('g',{attrs:{"id":"Screens","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Automation","transform":"translate(-427.000000, -91.000000)","fill":"#8492A6"}},[_c('g',{attrs:{"id":"Group-13","transform":"translate(138.000000, 48.000000)"}},[_c('path',{attrs:{"d":"M303.88537,46.6828571 C303.765372,46.5325714 300.905194,43 296.500042,43 C292.072391,43 289.231985,46.5342857 289.113351,46.6845714 C288.96199,46.876 288.96199,47.1251429 289.114715,47.3165714 C289.234712,47.4674286 292.094891,51 296.500042,51 C300.882694,51 303.763327,47.4691429 303.884006,47.3188571 C304.038095,47.1268571 304.038776,46.8754286 303.88537,46.6828571 Z M296.500042,49.8571429 C293.534184,49.8571429 291.29445,47.8022857 290.53219,46.9988571 C290.980819,46.5234286 291.946939,45.6131429 293.275779,44.9474286 C293.159191,45.2331429 293.09101,45.5377143 293.09101,45.8571429 C293.09101,47.4325714 294.620302,48.7142857 296.500042,48.7142857 C298.379783,48.7142857 299.909075,47.4325714 299.909075,45.8571429 C299.909075,45.54 299.841576,45.2371429 299.726351,44.9531429 C301.049055,45.6182857 302.015175,46.5245714 302.465849,46.9994286 C301.697453,47.804 299.448173,49.8571429 296.500042,49.8571429 Z","id":"Shape"}})])])])])
          )
        }
      }
    